import { createTypeGuard, getAssetContentMarker, isAssetPurchasable } from '../asset/utils';
import type { Linear } from '../compat/types';

import type {
  TopShelfSeriesAsset,
  TopShelfAsset,
  TopShelfEpisodeAsset,
  TopShelfMovieAsset,
  TopShelfPackageAsset,
  TopShelfProgramAsset,
  TopShelfVodAsset,
} from './types';

export const isTopShelfEpisodeAsset = createTypeGuard<TopShelfAsset, TopShelfEpisodeAsset>('episode');
export const isTopShelfMovieAsset = createTypeGuard<TopShelfAsset, TopShelfMovieAsset>('movie');
export const isTopShelfProgramAsset = createTypeGuard<TopShelfAsset, TopShelfProgramAsset>('program');
export const isTopShelfSeriesAsset = createTypeGuard<TopShelfAsset, TopShelfSeriesAsset>('series');
export const isTopShelfPackageAsset = createTypeGuard<TopShelfAsset, TopShelfPackageAsset>('package');

export const isTopShelfVodAsset = createTypeGuard<TopShelfAsset, TopShelfVodAsset>('movie', 'episode', 'series');

export function getTopShelfAssetDuration(asset: TopShelfAsset) {
  if (isTopShelfEpisodeAsset(asset) || isTopShelfMovieAsset(asset)) {
    return asset.duration;
  }

  if (isTopShelfProgramAsset(asset)) {
    return (asset.endDate - asset.startDate) / 1000;
  }
}

export function isTopShelfAssetPurchasable(asset: TopShelfAsset, channels: Map<number, Linear>) {
  if (isTopShelfProgramAsset(asset)) {
    return !channels.get(asset.channelId)?.linearEntitlement;
  }

  if (isTopShelfMovieAsset(asset) || isTopShelfEpisodeAsset(asset)) {
    return isAssetPurchasable(asset);
  }

  return false;
}

export function getTopShelfAssetContentMarker(asset: TopShelfAsset) {
  if (!isTopShelfVodAsset(asset)) {
    return undefined;
  }

  return getAssetContentMarker(asset);
}

export function getTopShelfAssetTitle(asset: TopShelfAsset) {
  const hasSeriesId = (isTopShelfEpisodeAsset(asset) || isTopShelfProgramAsset(asset)) && Boolean(asset.seriesId);

  if (hasSeriesId) {
    return asset.seriesName ?? asset.title;
  }

  return asset.title;
}
